import React, { Component } from "react"
import { LoadScript } from "services/Utils"
import { Input } from "antd"

export default class GoogleLocation extends Component {

  loadScript() {
    if (typeof window.google === "undefined") {
      LoadScript(
        `https://maps.googleapis.com/maps/api/js?key=AIzaSyDxe0pqmDuegFXpqdbrugXjW4sM7xEttzU&libraries=places`,
        () => {
          this.googleAutoCompleteInitializer()
        }
      )
    } else {
      this.googleAutoCompleteInitializer()
    }
  }

  googleAutoCompleteInitializer() {
    const { types, restrict, disabled } = this.props
    
    // Don't initialize if disabled
    if (disabled) {
      return;
    }
    
    const options = {
      types,
    }
    
    // Make sure inputText exists before creating autocomplete
    if (!this.inputText) {
      console.error('Input element not found');
      return;
    }
    
    const geoComponents = new window.google.maps.places.Autocomplete(this.inputText, options)
    if (restrict) {
      const cityBounds = new window.google.maps.LatLngBounds(
        new window.google.maps.LatLng(restrict.south_west.lat, restrict.south_west.lng),
        new window.google.maps.LatLng(restrict.north_east.lat, restrict.north_east.lng)
      )
      options.strictBounds = true
      options.bounds = cityBounds
      options.componentRestrictions = {}
      options.componentRestrictions.country = restrict.country.short_name.toLowerCase()
      geoComponents.setOptions(options)
    }
    window.google.maps.event.addDomListener(this.inputText, "keydown", (e) => {
      if (e.keyCode === 13) {
        e.preventDefault()
      }
    })

    window.google.maps.event.addListener(geoComponents, "place_changed", () => {
      const place = geoComponents.getPlace()
      if (!place.geometry) {
        console.log('No geometry found for selected place');
        return;
      }
      
      const location = {
        lat: place.geometry.location.lat(),
        lng: place.geometry.location.lng(),
        south_west: {
          lat: place.geometry.viewport.getSouthWest().lat(),
          lng: place.geometry.viewport.getSouthWest().lng(),
        },
        north_east: {
          lat: place.geometry.viewport.getNorthEast().lat(),
          lng: place.geometry.viewport.getNorthEast().lng(),
        },
        address: place.formatted_address,
      }
      place.address_components.map(component => (location[component.types[0]] = component))
      if (this.props.clearInput) {
        this.inputText.value = ""
        this.inputText.focus()
      }
      this.props.location(location)
    })
  }

  componentDidMount() {
    this.loadScript()
  }

  componentDidUpdate(prevProps) {
    // Re-initialize if the component becomes enabled
    if (prevProps.disabled && !this.props.disabled && this.inputText) {
      this.googleAutoCompleteInitializer()
    }
  }

  referenceHandler = (ref) => {
    // Fix the reference handling for Ant Design Input
    if (ref) {
      // Try different ways to get the input element
      this.inputText = ref.input || ref.inputElement || ref;
      
      // If we have the input element and not disabled, initialize autocomplete
      if (this.inputText && !this.props.disabled && typeof window.google !== "undefined") {
        setTimeout(() => {
          this.googleAutoCompleteInitializer()
        }, 100)
      }
    }
  }

  render() {
    const { placeholder, formValue, value, onChange, disabled } = this.props
    return (
      <Input
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        ref={this.referenceHandler}
        disabled={disabled}
      />
    )
  }
}
